import React from 'react';
import iconify from '../iconify';

const ArrowRight = ({customColor, ...props}) => (
  <svg width="5.84em" height="1em" viewBox="6977.25 3310.05 97 10.7" {...props}>
    <g
      fill="none"
      stroke={customColor ? customColor : 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth="1.5px"
      transform="translate(7011 3310)"
    >
      <path id="Path_43" data-name="Path 43" d="M58.6,10l3.9-4.6L58.6.8" />
      <line
        id="Line_1"
        data-name="Line 1"
        x1="95.5"
        transform="translate(-33 5.4)"
      />
    </g>
  </svg>
);

export default iconify(ArrowRight);
